export default __webpack_public_path__ + "static/media/grafema_angura_07.ffb16d82.jpg";